<!-- <deletemodal id="customer-tabs" [deleteModal]="deleteModal"></deletemodal> -->
<div class="row search-block no-margin">
    <form [formGroup]="myTicketsForm" novalidate (ngSubmit)="myTicketsSearchFormSubmit()">
        <!-- ticket dashborad -->
        <!-- ticket number -->
        <div class="form-horizontal customer-service-search-border customer-care-multiselect">
        <div class="row no-margin">
            <div class="child_1 col-xs-12 col-lg-6 p-0 ">
                <label for="ticketNumber"
                    class="control-label col-xs-1 col-lg-2 right-padding-0">{{'ticketing-system.Ticket Number' |translate}}</label>
                <div class="col-sm-7 col-md-5 col-lg-8 floating-input floatLabelContainer">
                    <input #ticketType id="ticketType" float-label tabindex="0" [(ngModel)]="ticketSearchModel.ticketNumber"
                        class="form-control" placeholder="{{'ticketing-system.Ticket #' |translate}}" tabindex="1" type="text"
                        autofocus (blur)="searchWithTicketNumber()" (keyup.enter)="onSearch()" formControlName="ticketNumber">
                </div>
                <!-- <div class="col-sm-4 col-md-6 col-lg-7">
                        <span>{{ticketSearchModel.ticketNumber}}</span>               
                    </div> -->
            </div>
            <!-- email -->
            <div class="child_2 col-xs-12 col-lg-6 p-0">
                <label for="Email"
                    class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Email' |translate}}</label>
                <div class="col-sm-7 col-md-5 col-lg-8 floating-input floatLabelContainer">
                    <input id="ticketType" float-label tabindex="0" class="form-control"
                        placeholder="{{'ticketing-system.Email Address' |translate}}" tabindex="1" type="email" autofocus
                        (blur)="searchWithTicketNumber()" (keyup.enter)="onSearch()" formControlName="email">
                    <div class="alert-msg"
                        *ngIf="myTicketsForm.get('email').hasError('pattern') && myTicketsForm.get('email').touched">
                        {{'validation-message.Enter a valid email address'|translate | translateKey}}
                    </div>
                </div>
            </div>
        </div>
        <!--Country Office-->
        <div class="row no-margin">
            <label for="ticketNumber" class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Country Office' |translate}}</label>
            <div class="col-sm-7 col-md-5 col-lg-4 floating-input floatLabelContainer">
                <select autofocus tabindex="0" (change)="ShowTicketAndDepatrmentBycountry($event.target.value)" id="autofocus-modal-element" class="form-control ng-pristine ng-invalid ng-touched"  formControlName="operatingCountryId" >
                <option *ngFor="let country of operatingCountries | orderBy:'name'" [value]="country.id">{{country.name}}</option>
            </select>
            </div>
        </div>
            <!-- ticket type -->
            <div class="row  no-margin">
                <label class="control-label col-xs-1 right-padding-0" for="{{'ticketing-system.Ticket Type' |translate}}">{{'ticketing-system.Ticket Type' |translate}}</label>
                <div class="col-sm-7 col-md-5 col-lg-4 floating-input">
                    <angular2-multiselect tabindex="1" (keyup.enter)="openDropDown('ticketType')"
                        id="ticketType" [data]="dropdownSettings.typeDropdownList" [(ngModel)]="dropdownSettings.typeSelectedItems"
                        [settings]="dropdownSettings.settings" (onSelect)="onItemSelect($event,dropdownSettings.typeIndex)" (onDeSelect)="onItemDeSelect($event,dropdownSettings.typeIndex)"
                        (onSelectAll)="onSelectAll($event,dropdownSettings.typeIndex)" (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.typeIndex)"
                        formControlName="type">
                    </angular2-multiselect>
                </div>
                <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="ticketTypeOnSelectAll && dropdownSettings.typeSelectedItems.length > 0">
                    {{'ticketing-system.ALL' |translate | translateKey}}
                </div>
                <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!ticketTypeOnSelectAll ">
                    <span *ngFor="let ticketType of dropdownSettings.typeSelectedItems| slice:0:8 ; let i=index">{{ticketType.itemName}}
                            <span *ngIf="(dropdownSettings.typeSelectedItems.length-1 > i) && !(i > 6)"> | </span>
                    </span>

                    <span class="addmore-link" *ngIf="dropdownSettings.typeSelectedItems.length > 8">{{'ticketing-system.and more' |translate |translateKey}}</span>
                </div>
            </div>
            <!-- subtype -->
            <div class="row  no-margin">
                <label class="control-label col-xs-1 right-padding-0">{{'ticketing-system.SubType' |translate |translateKey}}</label>
                <div class="col-sm-7 col-md-5 col-lg-4 floating-input">
                    <angular2-multiselect tabindex="1"  (keyup.enter)="openDropDown('subType')" id="subType"
                        [data]="dropdownSettings.subTypeDropdownList" [(ngModel)]="dropdownSettings.subTypeSelectedItems" [settings]="dropdownSettings.settings"
                        (onSelect)="onItemSelect($event,dropdownSettings.subTypeIndex)" (onDeSelect)="onItemDeSelect($event,dropdownSettings.subTypeIndex)"
                        (onSelectAll)="onSelectAll($event,dropdownSettings.subTypeIndex)" (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.subTypeIndex)" 
                        formControlName="subType">
                    </angular2-multiselect>
                </div>
                <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!subTypeOnSelectAll">
                    <span *ngFor="let subType of dropdownSettings.subTypeSelectedItems  | slice:0:8 ; let i=index">{{subType.itemName}}
                            <span *ngIf="(dropdownSettings.subTypeSelectedItems.length-1 > i) && !(i > 6)"> | </span>
                    </span>

                    <span class="addmore-link" *ngIf="dropdownSettings.subTypeSelectedItems.length > 8">{{'ticketing-system.and more' |translate |translateKey}}</span>
                </div>
                <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="subTypeOnSelectAll && dropdownSettings.subTypeSelectedItems.length > 0">
                    {{'ticketing-system.ALL' |translate | translateKey}}
                </div>
            </div>
            <!--Dispute Reason-->
            <div class="row  no-margin">
                <label class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Dispute Reason' |translate |translateKey}}</label>
                <div class="col-sm-7 col-md-5 col-lg-4 floating-input">
                    <angular2-multiselect tabindex="1"  (keyup.enter)="openDropDown('disputeReason')" id="disputeReason"
                        [data]="dropdownSettings.disputeReasonDropdownList" [(ngModel)]="dropdownSettings.disputeReasonSelectedItem" [settings]="dropdownSettings.settings"
                        (onSelect)="onItemSelect($event,dropdownSettings.disputeReasonIndex)" (onDeSelect)="onItemDeSelect($event,dropdownSettings.disputeReasonIndex)"
                        (onSelectAll)="onSelectAll($event,dropdownSettings.disputeReasonIndex)" (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.disputeReasonIndex)" 
                        formControlName="disputeReason">
                    </angular2-multiselect>
                </div>
                <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!disputeReasonOnSelectAll">
                    <span *ngFor="let reason of dropdownSettings.disputeReasonSelectedItem  | slice:0:8 ; let i=index">{{reason.itemName}}
                            <span *ngIf="(dropdownSettings.disputeReasonSelectedItem.length-1 > i) && !(i > 6)"> | </span>
                    </span>

                    <span class="addmore-link" *ngIf="dropdownSettings.disputeReasonSelectedItem.length > 8">{{'ticketing-system.and more' |translate |translateKey}}</span>
                </div>
                <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="disputeReasonOnSelectAll && dropdownSettings.disputeReasonSelectedItem.length > 0">
                    {{'ticketing-system.ALL' |translate | translateKey}}
                </div>
            </div>
            <!-- source -->
            <div class="row  no-margin">
                <label class="control-label col-xs-1 right-padding-0" for="{{'ticketing-system.Source' |translate}}">{{'ticketing-system.Source' |translate}} </label>
                <div class="col-sm-7 col-md-5 col-lg-4 floating-input">
                    <angular2-multiselect tabindex="1" (keyup.enter)="openDropDown('source')" id="source"
                        [data]="dropdownSettings.sourceDropdownList" [(ngModel)]="dropdownSettings.sourceSelectedItems" [settings]="dropdownSettings.settings"
                        (onSelect)="onItemSelect($event,dropdownSettings.sourceIndex)" (onDeSelect)="onItemDeSelect($event,dropdownSettings.sourceIndex)"
                        (onSelectAll)="onSelectAll($event,dropdownSettings.sourceIndex)" (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.sourceIndex)"
                        formControlName="source">
                    </angular2-multiselect>
                </div>
                 <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="sourceOnSelectAll && dropdownSettings.sourceSelectedItems.length > 0">
                {{'ticketing-system.ALL' |translate | translateKey}}
            </div>
            <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!sourceOnSelectAll">
                <span *ngFor="let source of dropdownSettings.sourceSelectedItems ; let i=index">{{source.itemName}}
                    <span *ngIf="(dropdownSettings.sourceSelectedItems.length-1 > i) && !(i > 2)"> | </span>
                </span>
            </div>
            </div>
            <!-- department -->
            <div class="row  no-margin">
                <label class="control-label col-xs-1 right-padding-0" for="{{'ticketing-system.Department' |translate}}">{{'ticketing-system.Assign to Department' |translate}}</label>
                <div class="col-sm-7 col-md-5 col-lg-4 floating-input">
                    <angular2-multiselect tabindex="1" (keyup.enter)="openDropDown('department')"
                        id="department" [data]="dropdownSettings.departmentDropdownList" [(ngModel)]="dropdownSettings.departmentSelectedItems"
                        [settings]="dropdownSettings.settings" (onSelect)="onItemSelect($event,dropdownSettings.departmentIndex)"
                        (onDeSelect)="onItemDeSelect($event,dropdownSettings.departmentIndex)" (onSelectAll)="onSelectAll($event,dropdownSettings.departmentIndex)"
                        (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.departmentIndex)" formControlName="department">
                    </angular2-multiselect>
                </div>
                 <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="departmentOnSelectAll && dropdownSettings.departmentSelectedItems.length > 0">
                {{'ticketing-system.ALL' |translate | translateKey}}
            </div>
            <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!departmentOnSelectAll">
                <span *ngFor="let teamdepartment of dropdownSettings.departmentSelectedItems| slice:0:8 ; let i=index">
                    {{teamdepartment.itemName}}
                    <span *ngIf="(dropdownSettings.departmentSelectedItems.length-1 > i) && !(i > 6)"> | </span>
                </span>
                <span class="addmore-link" *ngIf="dropdownSettings.departmentSelectedItems.length > 8">{{'ticketing-system.and more' |translate |translateKey}}</span>
            </div>
            </div>
            <!-- status -->
            <div class="row  no-margin">
                <label class="control-label col-xs-1 right-padding-0" for="{{'ticketing-system.Status' |translate}}">{{'ticketing-system.Status' |translate}}</label>
                <div class="col-sm-7 col-md-5 col-lg-4 floating-input">
                    <!-- <input  formControlName="showAllTickets" tabindex="0" type="checkbox" (change)="showAllTicketsCheckBox($event)" >
                    <label for="{{'ticketing-system.Show all Tickets' |translate}}">
                        &nbsp;&nbsp;{{'ticketing-system.Show all Tickets' |translate}}
                    </label> -->
                    <angular2-multiselect tabindex="1" (keyup.enter)="openDropDown('status')" id="status"
                        [data]="dropdownSettings.statusDropdownList" [(ngModel)]="dropdownSettings.statusSelectedItems" [settings]="dropdownSettings.settings"
                        (onSelect)="onItemSelect($event,dropdownSettings.statusIndex)" (onDeSelect)="onItemDeSelect($event,dropdownSettings.statusIndex)"
                        (onSelectAll)="onSelectAll($event,dropdownSettings.statusIndex)" (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.statusIndex)"
                        formControlName="status">
                    </angular2-multiselect>
                </div>
                 <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!statusOnSelectAll">
                <span *ngFor="let status of dropdownSettings.statusSelectedItems ; let i=index">{{status.itemName}}
                    <span *ngIf="(dropdownSettings.statusSelectedItems.length-1 > i) && !(i > 2)"> | </span>

                </span>
            </div>
            <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="statusOnSelectAll && dropdownSettings.statusSelectedItems.length > 0">
                {{'ticketing-system.ALL' |translate | translateKey}}
            </div>
            </div>
            <!-- priority -->
            <div class="row  no-margin">
                <label class="control-label col-xs-1 right-padding-0" for="{{'ticketing-system.Priority' |translate}}">{{'ticketing-system.Priority' |translate}}</label>
                <div class="col-sm-7 col-md-5 col-lg-4 floating-input">
                    <angular2-multiselect tabindex="1" (keyup.enter)="openDropDown('priority')" id="priority"
                        [data]="dropdownSettings.priorityDropdownList" [(ngModel)]="dropdownSettings.prioritySelectedItems" [settings]="dropdownSettings.settings"
                        (onSelect)="onItemSelect($event,dropdownSettings.priorityIndex)" (onDeSelect)="onItemDeSelect($event,dropdownSettings.priorityIndex)"
                        (onSelectAll)="onSelectAll($event,dropdownSettings.priorityIndex)" (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.priorityIndex)" 
                        formControlName="priority">
                    </angular2-multiselect>
                </div>
                 <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="priorityOnSelectAll && dropdownSettings.prioritySelectedItems.length > 0">
                {{'ticketing-system.ALL' |translate | translateKey}}
            </div>
            <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!priorityOnSelectAll">
                <span *ngFor="let teampriority of  dropdownSettings.prioritySelectedItems ; let i=index">{{teampriority.itemName}}
                    <span *ngIf="(dropdownSettings.prioritySelectedItems.length-1 > i) && !(i > 2)"> | </span>
                </span>

            </div>
            </div>
             <!-- Assign To -->
             <div class="row no-margin">
                <label for="{{'ticketing-system.Created By' |translate}}" class="control-label col-xs-1 right-padding-0">{{'ticketing-system.Created By' |translate}}</label>
                <div class="col-sm-7 col-md-5 col-lg-4 floating-input">
                    <angular2-multiselect tabindex="0" (keyup.enter)="openDropDown('createdBy')" id="createdBy"
                  [data]="dropdownSettings.createdByDropdownList" [(ngModel)]="dropdownSettings.createdBySelectedItems" 
                              [settings]="dropdownSettings.settings" 
                              (onSelect)="onItemSelect($event,dropdownSettings.createdByIndex)"
                              (onDeSelect)="onItemDeSelect($event,dropdownSettings.createdByIndex)" 
                              (onSelectAll)="onSelectAll($event,dropdownSettings.createdByIndex)" 
                              (onDeSelectAll)="onDeSelectAll($event,dropdownSettings.createdByIndex)"  formControlName="createdBy" >
                    </angular2-multiselect>
                </div>
                <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="createdByOnSelectAll && dropdownSettings.createdBySelectedItems.length > 0">
                    {{'ticketing-system.ALL' |translate | translateKey}}
                </div>
                <div class="col-sm-4 col-md-6 col-lg-7" *ngIf="!createdByOnSelectAll">
                    <span *ngFor="let created of dropdownSettings.createdBySelectedItems| slice:0:8 ; let i=index">
                        {{created.itemName}}
                        <span *ngIf="(dropdownSettings.createdBySelectedItems.length-1 > i) && !(i > 6)"> | </span>
                    </span>
                    <span class="addmore-link" *ngIf="dropdownSettings.createdBySelectedItems.length > 8">{{'ticketing-system.and more' |translate |translateKey}}</span>
                </div>
            </div>
            <div class="row no-margin mb-10">
                <label for="ticketNumber" class="control-label col-xs-1 right-padding-0"></label>
                <div class="col-xs-8">
                        <input float-label tabindex="1" [(ngModel)]="ticketSearchModel.overDueCount"
                        type="checkbox" (keyup.enter)="onSearch()" formControlName="overDueCount"/>{{'ticketing-system.Show Tickets Past Due Date' |translate |translateKey}}
                </div>
            </div>
           
        </div>
        <!-- buttons -->
        <!--<div class="form-group col-xs-12 col-md-1 margintop-32">
                    <button class="btn search-button" tabindex="0" type="submit" >
                        <i  class="fa fa-search pad-r-8"></i> {{'ticketing-system.Search' |translate}}
                    </button>
                </div>-->

        <!-- <div class="pull-right button-block">
            <button class="btn blue-button" tabindex="0" type="submit" (keyup.enter)="onSearch()"  (click)="onSearch()">{{'ticketing-system.Search' |translate}}</button>
            <button class="btn grey-button" tabindex="0" type="button" (keyup.enter)="clearFields()" (click)="clearFields()">{{'ticketing-system.Cancel' |translate}}</button>
        </div> -->
        <button type="button" tabindex="2" [disabled]="!allTickets.length" (keyup.enter)="Download()" (click)="Download()" class="myTicketsButton">
            <span class="btn-label">
                <img class="excel-image" [src]="excelIconUrl" alt="Excel Icon">
            </span>
        </button>
        <div class="pull-right button-block">
            <button class="btn blue-button"  id="search-button" tabindex="2" [disabled]="(!!(myTicketsForm.get('ticketNumber').value && myTicketsForm.get('email').value ) || !myTicketsForm.valid)"  type="submit" (keyup.enter)="onSearch()" type="button" (click)="onSearch()">{{'ticketing-system.Search' |translate}}</button>
            <button class="btn grey-button" tabindex="2" type="button" (click)="clearFields()">{{'ticketing-system.CLEAR' | translate | translateKey}}</button>                
        </div>
    </form>
</div>


<div class="col-md-12 no-padding card">
    <div class="table-responsive pane-hScroll">
            <table class="tickets-display table table-striped custab ticket-dashbaord ticket-response">
                <thead>
                    <tr>
                        <th class="width-25 pointer" (click)="sortTableByColumn('PRIORITY')">{{'ticketing-system.Priority' |translate}}&nbsp;
                            <i class="fa fa-sort" tabindex="0" (keyup.enter)="sortTableByColumn('PRIORITY')" (click)="sortTableByColumn('PRIORITY')"
                                [ngClass]="{'fa-sort': sortColumn != 'PRIORITY', 'fa-sort-asc': (sortColumn  == 'PRIORITY' && !isDesc), 'fa-sort-desc': (sortColumn  == 'PRIORITY' && isDesc) }"
                                style="font-size:12px"></i>
                        </th>
                        <th class="width-25 pointer" tabindex="0" (keyup.enter)="sortTableByColumn('TICKET_NUMBER')" (click)="sortTableByColumn('TICKET_NUMBER')">{{'ticketing-system.Ticket #' |translate}}&nbsp;
                            <i class="fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'TICKET_NUMBER', 'fa-sort-asc': (sortColumn  == 'TICKET_NUMBER' && !isDesc), 'fa-sort-desc': (sortColumn  == 'TICKET_NUMBER' && isDesc) }"
                                style="font-size:12px"></i>
                        </th>
                        <th>{{'ticketing-system.Subject' |translate}}
                        </th>
                        <th class="width-50 pointer" tabindex="0" (keyup.enter)="sortTableByColumn('SUBTYPE')" (click)="sortTableByColumn('SUBTYPE')">{{'ticketing-system.Subtype'| translate}} &nbsp;
                            <i class="fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'SUBTYPE', 'fa-sort-asc': (sortColumn  == 'SUBTYPE' && !isDesc), 'fa-sort-desc': (sortColumn  == 'SUBTYPE' && isDesc) }"
                                style="font-size:12px"></i>
                        </th>
                        <th class="width-50 pointer" tabindex="0" (keyup.enter)="sortTableByColumn('DISPUTE_REASON')" (click)="sortTableByColumn('DISPUTE_REASON')">{{'ticketing-system.Dispute Reason'| translate}} &nbsp;
                            <i class="fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'DISPUTE_REASON', 'fa-sort-asc': (sortColumn  == 'DISPUTE_REASON' && !isDesc), 'fa-sort-desc': (sortColumn  == 'DISPUTE_REASON' && isDesc) }"
                                style="font-size:12px"></i>
                        </th>
                        <th class="width-25 pointer" tabindex="0" (keyup.enter)="sortTableByColumn('STATUS')" (click)="sortTableByColumn('STATUS')">{{'ticketing-system.Status' |translate}}&nbsp;
                            <i class="fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'STATUS', 'fa-sort-asc': (sortColumn  == 'STATUS' && !isDesc), 'fa-sort-desc': (sortColumn  == 'STATUS' && isDesc) }"
                                style="font-size:12px"></i>
                        </th>
                        <th class="width-25 pointer" tabindex="0" (keyup.enter)="sortTableByColumn('DUE_DATE')" (click)="sortTableByColumn('DUE_DATE')">{{'ticketing-system.Due Date' |translate}}&nbsp;
                            <i class="fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'DUE_DATE', 'fa-sort-asc': (sortColumn  == 'dueDate' && !isDesc), 'fa-sort-desc': (sortColumn  == 'DUE_DATE' && isDesc) }"
                                style="font-size:12px"></i>
                        </th>
                        <th class="width-30 pointer" tabindex="0" (keyup.enter)="sortTableByColumn('CREATED_DATE')" (click)="sortTableByColumn('CREATED_DATE')">{{'ticketing-system.Created' |translate}}&nbsp;&nbsp;{{'ticketing-system.Date'|translate}}
                            <i class="fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'CREATED_DATE', 'fa-sort-asc': (sortColumn  == 'CREATED_DATE' && !isDesc), 'fa-sort-desc': (sortColumn  == 'CREATED_DATE' && isDesc) }"
                                style="font-size:12px"></i>
                        </th>
                        <th class="width-30 pointer" tabindex="0" (keyup.enter)="sortTableByColumn('CREATED_BY')" (click)="sortTableByColumn('CREATED_BY')">{{'ticketing-system.Created By' |translate}}&nbsp;
                            <i class="fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'CREATED_BY', 'fa-sort-asc': (sortColumn  == 'CREATED_BY' && !isDesc), 'fa-sort-desc': (sortColumn  == 'CREATED_BY' && isDesc) }"
                                style="font-size:12px"></i>
                        </th>
                        <th class="width-40 pointer" tabindex="0" (keyup.enter)="sortTableByColumn('UPDATED_DATE')" (click)="sortTableByColumn('UPDATED_DATE')">{{'ticketing-system.Last Modified Date' |translate}}&nbsp;
                            <i class="fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'UPDATED_DATE', 'fa-sort-asc': (sortColumn  == 'UPDATED_DATE' && !isDesc), 'fa-sort-desc': (sortColumn  == 'UPDATED_DATE' && isDesc) }"
                                style="font-size:12px"></i>
                        </th>                       
                    </tr>

                </thead>
                <tbody>
                    <tr *ngFor="let ticket of myTickets | paginate: {  id: 'my-tickets-pagination', itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount }">
                        <td><span class="label label-default" [class]="ticket.priorityValue.toLowerCase()">&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;&nbsp;{{ticket.priorityValue}}</td>
                        <td *ngIf="isTicketView" class="ticket-number">
                            <a [ngClass]="{'color-warning':ticket.overDueTicket}" tabindex="0" (keyup.enter)="goToViewTicket(ticket.id,ticket.ticketNumber,true)"
                                (click)="goToViewTicket(ticket.id,ticket.ticketNumber,true)">{{ticket.ticketNumber}}</a></td>
                        <td *ngIf="!isTicketView" class="ticket-number" [ngClass]="{'color-warning':ticket.overDueTicket}">{{ticket.ticketNumber}}</td>
                        <td>{{ticket.subject}} </td>
                        <td>{{ticket.subType}}</td>
                        <td>{{ticket.disputeReasonName}}</td>
                        <td>{{ticket.status}}</td>
                        <td>{{ticket.dueDate}}</td>
                        <td>{{ticket.createdDate}}</td>
                        <td>{{ticket.createdByName}}</td>
                        <td>{{ticket.modifiedDate}}</td>
                        
                    </tr>
                </tbody>
                                  
                <tbody *ngIf="myTickets.length === 0">
                    <tr>
                        <td colspan="8" class="text-center" style="text-align: center">{{'ticketing-system.No records found' |translate | translateKey}}.</td>
                    </tr>
                </tbody>
                
            </table>

    </div>
    <div class="absolute-position" *ngIf="myTickets.length > 0">
        
        <span>{{pageCount}} {{'store-user.record(s) found' |translate | translateKey}}</span>
    </div>
    <pagination-controls [id]="paginationInstance.id" (pageChange)="pageChange($event)" class="pull-right"></pagination-controls>
    <div class="pull-left margin_top-5 floating-input">
        <select tabindex="0" [(ngModel)]="pageSize" class="form-control" (change)="pageChange(1)">
            <option *ngFor="let pageSize of pageSizes" [value]="pageSize">
                {{pageSize}}</option>
        </select>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/my-tickets.component.html